// extracted by mini-css-extract-plugin
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var green = "#3dae2b";
export var lightGreen = "#93d500";
export var newsGreen = "#ecf5d7";
export var orange = "#f90";
export var yellow = "#fbc900";
export var paleBlue = "#64a1bb";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var coolGrey = "#e1e2e0";
export var white = "#fff";
export var almostWhite = "#f2eded";
export var lightGrey = "#d3d3d3";
export var lightishGrey = "#aba9a9";
export var grey = "#828382";
export var darkishGrey = "#666";
export var darkGrey = "#4b4d4b";
export var almostBlack = "#333";
export var error = "#ff3a3a";
export var warning = "#ffd162";
export var success = "#1ebc7b";
export var wrapper = "VideoSection-module--wrapper--3AbKl";
export var section = "VideoSection-module--section--1q49T";
export var whiteBackground = "VideoSection-module--whiteBackground--3FQQQ";
export var noPaddingTop = "VideoSection-module--noPaddingTop--3Sbrp";
export var container = "VideoSection-module--container--3ptV0";
export var title = "VideoSection-module--title--31YF1";
export var labelAndFiltersContainer = "VideoSection-module--labelAndFiltersContainer--3HcTM";
export var blueBordersLabel = "VideoSection-module--blueBordersLabel--2K0h_";
export var filtersContainer = "VideoSection-module--filtersContainer--3fR45";
export var filterContainer = "VideoSection-module--filterContainer--MMQjd";
export var filter = "VideoSection-module--filter--lOtDq";
export var filterBox = "VideoSection-module--filterBox--1s5OS";
export var videos = "VideoSection-module--videos--Mvv2f";
export var videoWrapper = "VideoSection-module--videoWrapper--2YO_8";